import React from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Users, UserPlus, UserMinus, RefreshCw, Search, CheckCircle, Clock, FileText, TrendingUp, Calendar, Calculator, Eye } from 'lucide-react';

import { useGestionMembresCooper } from './useGestionMembresCooper';
import GestionMembresCooperModals from './GestionMembresCooperModals';

export default function GestionMembresCooper() {
  const ctx = useGestionMembresCooper();
  const { _coopers, fetchData, fetchMembreSimulations, filter, filteredMembres, _handleBulkAssign, handleCreateNewSimulation, _handleFinalizeSimulation, _handleResumeSimulation, handleSelectAll, handleSelectOne, handleUnassign, loading, _loadingSimulations, _membreSimulations, _membres, searchQuery, _selectedCooper, selectedIds, _selectedMembreForSimulation, _showAssignModal, _showSimulationsModal, stats, setShowAssignModal, setFilter, setSearchQuery, setSelectedIds } = ctx;
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      {/* Header de section ultra pro */}
      <div className="rounded-2xl bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-600 text-white p-6 shadow-lg relative overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 30% 20%, white 0%, transparent 50%)' }} />
        <div className="relative flex items-start justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-white/20 backdrop-blur-sm border-2 border-white/30 flex items-center justify-center shadow-lg flex-shrink-0">
              <Users className="h-7 w-7 text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-bold leading-tight">Gestion Membres / COOPER&apos;S</h2>
              <p className="text-sm text-white/80 mt-1">Assignation des membres adhérents aux COOPER&apos;S et suivi des simulations BATICO</p>
            </div>
          </div>
          <Button onClick={fetchData} variant="secondary" size="sm" className="bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white border-0 gap-2">
            <RefreshCw className="h-4 w-4" /> Actualiser
          </Button>
        </div>
      </div>

      {/* Statistiques — cards gradient pro */}
      {stats && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          <Card className="border-0 shadow-md bg-gradient-to-br from-blue-50 via-blue-50/30 to-white border-l-4 border-l-blue-500 hover:shadow-lg transition-all">
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <div className="flex-1 min-w-0">
                  <p className="text-[11px] font-bold text-blue-700 uppercase tracking-wider">Total Membres</p>
                  <p className="text-3xl font-bold text-slate-900 mt-1 leading-none">{stats.membres.total}</p>
                </div>
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-md flex-shrink-0">
                  <Users className="h-5 w-5 text-white" />
                </div>
              </div>
              {stats.derniere_creation && (
                <div className="flex items-center gap-1 text-[10px] text-slate-500 pt-2 border-t border-blue-100">
                  <Calendar className="h-3 w-3" />
                  <span>Dernier : <strong className="text-blue-700">{new Date(stats.derniere_creation).toLocaleDateString('fr-FR')}</strong></span>
                </div>
              )}
            </CardContent>
          </Card>

          <Card className="border-0 shadow-md bg-gradient-to-br from-emerald-50 via-emerald-50/30 to-white border-l-4 border-l-emerald-500 hover:shadow-lg transition-all">
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <div className="flex-1 min-w-0">
                  <p className="text-[11px] font-bold text-emerald-700 uppercase tracking-wider">Assignés</p>
                  <p className="text-3xl font-bold text-emerald-700 mt-1 leading-none">{stats.membres.assignes}</p>
                </div>
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-emerald-500 to-green-600 flex items-center justify-center shadow-md flex-shrink-0">
                  <CheckCircle className="h-5 w-5 text-white" />
                </div>
              </div>
              {stats.derniere_assignation && (
                <div className="flex items-center gap-1 text-[10px] text-slate-500 pt-2 border-t border-emerald-100">
                  <Calendar className="h-3 w-3" />
                  <span>Dernier : <strong className="text-emerald-700">{new Date(stats.derniere_assignation).toLocaleDateString('fr-FR')}</strong></span>
                </div>
              )}
            </CardContent>
          </Card>

          <Card className="border-0 shadow-md bg-gradient-to-br from-amber-50 via-amber-50/30 to-white border-l-4 border-l-amber-500 hover:shadow-lg transition-all">
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <div className="flex-1 min-w-0">
                  <p className="text-[11px] font-bold text-amber-700 uppercase tracking-wider">Non Assignés</p>
                  <p className="text-3xl font-bold text-amber-600 mt-1 leading-none">{stats.membres.non_assignes}</p>
                </div>
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center shadow-md flex-shrink-0">
                  <Clock className="h-5 w-5 text-white" />
                </div>
              </div>
              {stats.plus_ancien_non_assigne && (
                <div className="flex items-center gap-1 text-[10px] text-slate-500 pt-2 border-t border-amber-100">
                  <Calendar className="h-3 w-3" />
                  <span>+ ancien : <strong className="text-amber-700">{new Date(stats.plus_ancien_non_assigne).toLocaleDateString('fr-FR')}</strong></span>
                </div>
              )}
            </CardContent>
          </Card>

          <Card className="border-0 shadow-md bg-gradient-to-br from-purple-50 via-purple-50/30 to-white border-l-4 border-l-purple-500 hover:shadow-lg transition-all">
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <div className="flex-1 min-w-0">
                  <p className="text-[11px] font-bold text-purple-700 uppercase tracking-wider">Taux Assignation</p>
                  <p className="text-3xl font-bold text-purple-700 mt-1 leading-none">{stats.membres.taux_assignation}<span className="text-lg">%</span></p>
                </div>
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center shadow-md flex-shrink-0">
                  <TrendingUp className="h-5 w-5 text-white" />
                </div>
              </div>
              {/* Barre de progression */}
              <div className="pt-2 border-t border-purple-100">
                <div className="h-1.5 rounded-full bg-purple-100 overflow-hidden">
                  <div
                    className="h-full bg-gradient-to-r from-purple-500 to-pink-500 transition-all duration-700 rounded-full"
                    style={{ width: `${Math.min(100, stats.membres.taux_assignation || 0)}%` }}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Bandeau actions en masse — animé */}
      {selectedIds.length > 0 && (
        <Card className="border-2 border-blue-300 bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 shadow-md animate-in fade-in duration-200">
          <CardContent className="p-4">
            <div className="flex items-center justify-between gap-4 flex-wrap">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-md">
                  <CheckCircle className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="font-bold text-blue-900 text-base leading-tight">
                    {selectedIds.length} membre{selectedIds.length > 1 ? 's' : ''} sélectionné{selectedIds.length > 1 ? 's' : ''}
                  </p>
                  <p className="text-xs text-blue-700 mt-0.5">Choisissez une action à appliquer en masse</p>
                </div>
              </div>
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setSelectedIds([])}
                  className="border-blue-300 text-blue-700 hover:bg-blue-100"
                >
                  Désélectionner
                </Button>
                <Button
                  onClick={() => setShowAssignModal(true)}
                  className="bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white shadow-md gap-2"
                >
                  <UserPlus className="h-4 w-4" />
                  Assigner à un COOPER&apos;S
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Filtres et recherche — toolbar pro */}
      <Card className="border-0 shadow-sm bg-white">
        <CardContent className="p-4">
          <div className="flex flex-col md:flex-row gap-3 items-start md:items-center">
            <div className="flex-1 relative w-full">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" />
              <input
                type="text"
                placeholder="Rechercher par raison sociale, SIRET, email…"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-slate-50/50 hover:bg-white"
                data-testid="membres-cooper-search"
              />
              {searchQuery && (
                <button
                  type="button"
                  onClick={() => setSearchQuery('')}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 text-xs font-medium"
                >
                  Effacer
                </button>
              )}
            </div>

            <div className="flex items-center gap-2 bg-slate-100 rounded-lg p-1">
              <button
                onClick={() => setFilter('all')}
                className={`px-3 py-1.5 text-xs font-semibold rounded-md transition-all ${filter === 'all' ? 'bg-white shadow-sm text-blue-700' : 'text-slate-600 hover:text-slate-900'}`}
                data-testid="filter-all"
              >
                Tous
                {stats && <span className="ml-1.5 text-[10px] font-mono opacity-70">{stats.membres.total}</span>}
              </button>
              <button
                onClick={() => setFilter('assigned')}
                className={`px-3 py-1.5 text-xs font-semibold rounded-md transition-all flex items-center gap-1.5 ${filter === 'assigned' ? 'bg-white shadow-sm text-emerald-700' : 'text-slate-600 hover:text-slate-900'}`}
                data-testid="filter-assigned"
              >
                <CheckCircle className="h-3 w-3" /> Assignés
                {stats && <span className="ml-1 text-[10px] font-mono opacity-70">{stats.membres.assignes}</span>}
              </button>
              <button
                onClick={() => setFilter('unassigned')}
                className={`px-3 py-1.5 text-xs font-semibold rounded-md transition-all flex items-center gap-1.5 ${filter === 'unassigned' ? 'bg-white shadow-sm text-amber-700' : 'text-slate-600 hover:text-slate-900'}`}
                data-testid="filter-unassigned"
              >
                <Clock className="h-3 w-3" /> Non assignés
                {stats && <span className="ml-1 text-[10px] font-mono opacity-70">{stats.membres.non_assignes}</span>}
              </button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Liste des membres — header pro */}
      <Card className="border-0 shadow-md overflow-hidden">
        <CardHeader className="bg-gradient-to-r from-slate-50 to-white border-b py-3">
          <CardTitle className="flex items-center justify-between flex-wrap gap-2">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-slate-700 to-slate-900 flex items-center justify-center">
                <Users className="h-4 w-4 text-white" />
              </div>
              <div>
                <h3 className="text-base font-bold text-slate-900 leading-tight">Membres Adhérents</h3>
                <p className="text-xs text-slate-500 font-normal">{filteredMembres.length} résultat{filteredMembres.length > 1 ? 's' : ''}{searchQuery && ` pour "${searchQuery}"`}</p>
              </div>
            </div>
            {filteredMembres.length > 0 && (
              <label className="flex items-center gap-2 text-xs font-medium cursor-pointer text-slate-600 hover:text-slate-900 select-none px-3 py-1.5 rounded-lg hover:bg-slate-100 transition-colors">
                <input
                  type="checkbox"
                  checked={selectedIds.length === filteredMembres.length && filteredMembres.length > 0}
                  onChange={handleSelectAll}
                  className="rounded border-slate-300"
                />
                Tout sélectionner ({filteredMembres.length})
              </label>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {filteredMembres.length === 0 ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 mx-auto rounded-full bg-slate-100 flex items-center justify-center mb-3">
                <Users className="h-8 w-8 text-slate-400" />
              </div>
              <p className="text-slate-700 font-medium">Aucun membre trouvé</p>
              <p className="text-xs text-slate-500 mt-1">Essayez de modifier vos filtres ou votre recherche</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b bg-slate-50/50">
                    <th className="text-left px-4 py-3 w-10"></th>
                    <th className="text-left px-4 py-3 text-[11px] font-bold text-slate-600 uppercase tracking-wider">Membre</th>
                    <th className="text-left px-4 py-3 text-[11px] font-bold text-slate-600 uppercase tracking-wider">COOPER&apos;S Assigné</th>
                    <th className="text-left px-4 py-3 text-[11px] font-bold text-slate-600 uppercase tracking-wider">Simulations BATICO</th>
                    <th className="text-left px-4 py-3 text-[11px] font-bold text-slate-600 uppercase tracking-wider">Dossiers</th>
                    <th className="text-left px-4 py-3 text-[11px] font-bold text-slate-600 uppercase tracking-wider">Dates</th>
                    <th className="text-left px-4 py-3 text-[11px] font-bold text-slate-600 uppercase tracking-wider">Statut</th>
                    <th className="text-right px-4 py-3 text-[11px] font-bold text-slate-600 uppercase tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMembres.map(membre => (
                    <tr key={membre.id} className="border-b hover:bg-blue-50/30 transition-colors">
                      <td className="px-4 py-3">
                        <input
                          type="checkbox"
                          checked={selectedIds.includes(membre.id)}
                          onChange={() => handleSelectOne(membre.id)}
                          className="rounded border-slate-300"
                        />
                      </td>
                      <td className="px-4 py-3">
                        <div className="min-w-0">
                          <p className="font-semibold text-slate-900 text-sm leading-tight">{membre.raison_sociale || membre.entreprise || '—'}</p>
                          <p className="text-[11px] text-slate-500 font-mono mt-0.5">SIRET&nbsp;: {membre.siret || '—'}</p>
                          <p className="text-[11px] text-slate-500 truncate max-w-xs mt-0.5">{membre.email || '—'}</p>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        {membre.cooper_info ? (
                          <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                              {(membre.cooper_info.prenom?.[0] || '') + (membre.cooper_info.nom?.[0] || '')}
                            </div>
                            <div className="min-w-0">
                              <p className="font-semibold text-sm text-slate-900 leading-tight">
                                {membre.cooper_info.prenom} {membre.cooper_info.nom}
                              </p>
                              <p className="text-[10px] text-slate-500 truncate max-w-[180px]">{membre.cooper_info.email}</p>
                            </div>
                          </div>
                        ) : (
                          <Badge className="bg-amber-600 text-white border border-amber-800 font-semibold gap-1">
                            <Clock className="h-3 w-3" />
                            Non assigné
                          </Badge>
                        )}
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex flex-col gap-1.5">
                          <Button
                            onClick={() => fetchMembreSimulations(membre)}
                            size="sm"
                            variant="outline"
                            className="h-7 text-[11px] text-amber-700 border-amber-300 hover:bg-amber-50 gap-1.5 font-medium"
                            data-testid={`view-simulations-${membre.id}`}
                          >
                            <Eye className="h-3 w-3" />
                            <span className="hidden md:inline">Voir</span>
                          </Button>
                          <Button
                            onClick={() => handleCreateNewSimulation(membre)}
                            size="sm"
                            variant="outline"
                            className="h-7 text-[11px] text-emerald-700 border-emerald-300 hover:bg-emerald-50 gap-1.5 font-medium"
                            data-testid={`new-simulation-${membre.id}`}
                          >
                            <Calculator className="h-3 w-3" />
                            <span className="hidden md:inline">Nouvelle</span>
                          </Button>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        {membre.dossiers_stats ? (
                          <div className="text-xs">
                            <p className="font-semibold text-slate-900 mb-1">
                              {membre.dossiers_stats.traites}/{membre.dossiers_stats.total} traités
                            </p>
                            <div className="flex flex-wrap gap-1">
                              <Badge className="bg-emerald-700 text-white border border-emerald-900 text-[10px] gap-1 px-1.5 py-0 h-5 font-semibold">
                                <FileText className="h-2.5 w-2.5" />
                                {membre.dossiers_stats.traites} clos
                              </Badge>
                              {membre.dossiers_stats.en_cours > 0 && (
                                <Badge className="bg-blue-700 text-white border border-blue-900 text-[10px] gap-1 px-1.5 py-0 h-5 font-semibold">
                                  <Clock className="h-2.5 w-2.5" />
                                  {membre.dossiers_stats.en_cours} en cours
                                </Badge>
                              )}
                            </div>
                          </div>
                        ) : (
                          <span className="text-[11px] text-slate-400 italic">Aucun dossier</span>
                        )}
                      </td>
                      <td className="px-4 py-3">
                        <div className="text-[10px] space-y-0.5">
                          {membre.created_at && (
                            <div className="flex items-center gap-1 text-slate-500">
                              <Calendar className="h-2.5 w-2.5" />
                              <span>Créé&nbsp;: <strong className="text-slate-700">{new Date(membre.created_at).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' })}</strong></span>
                            </div>
                          )}
                          {membre.validated_at && (
                            <div className="flex items-center gap-1 text-emerald-600">
                              <CheckCircle className="h-2.5 w-2.5" />
                              <span>Validé&nbsp;: <strong>{new Date(membre.validated_at).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' })}</strong></span>
                            </div>
                          )}
                          {membre.assigned_at && (
                            <div className="flex items-center gap-1 text-blue-600">
                              <UserPlus className="h-2.5 w-2.5" />
                              <span>Assigné&nbsp;: <strong>{new Date(membre.assigned_at).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' })}</strong></span>
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <Badge className={`gap-1 font-semibold ${membre.cooper_assigne ? 'bg-emerald-100 text-emerald-800 border border-emerald-200' : 'bg-amber-100 text-amber-800 border border-amber-200'}`}>
                          {membre.cooper_assigne ? (
                            <><CheckCircle className="h-3 w-3" /> Assigné</>
                          ) : (
                            <><Clock className="h-3 w-3" /> En attente</>
                          )}
                        </Badge>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex gap-1.5 justify-end">
                          {membre.cooper_assigne ? (
                            <Button
                              onClick={() => handleUnassign(membre.id)}
                              size="sm"
                              variant="outline"
                              className="h-8 w-8 p-0 text-red-600 border-red-200 hover:bg-red-50 hover:border-red-300"
                              title="Désassigner"
                            >
                              <UserMinus className="h-3.5 w-3.5" />
                            </Button>
                          ) : (
                            <Button
                              onClick={() => {
                                setSelectedIds([membre.id]);
                                setShowAssignModal(true);
                              }}
                              size="sm"
                              className="h-8 text-xs gap-1.5 bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white shadow-sm font-medium"
                              title="Assigner à un COOPER'S"
                            >
                              <UserPlus className="h-3.5 w-3.5" />
                              Assigner
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>

      <GestionMembresCooperModals ctx={ctx} />
    </div>
  );
}
